import { FC, Fragment } from 'react';
import styled, { useTheme } from 'styled-components';

import Text from '@/components/Text';

const Notification = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 4px;
  border: 0.5px solid ${({ theme }) => theme.colors.error};
  background: ${({ theme }) => theme.colors.errorLight};

  strong {
    font-weight: 700;
  }
`;

const Title = styled(Text)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Inner = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: 20% 80%;
  column-gap: 30px;
  row-gap: 12px;
`;

const Wrap = styled.div`
  grid-column: span 2;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

interface Props {
  errors: { [rowNumber: number]: string };
}

const CsvImportErrors: FC<Props> = ({ errors }) => {
  const theme = useTheme();

  const rows = Object.keys(errors);

  if (!rows.length) {
    return null;
  }

  return (
    <Wrap>
      <Notification>
        <Title $type="smallBold">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="8"
              cy="8"
              r="7.5"
              fill={theme.colors.error}
              stroke={theme.colors.error}
            />
            <path
              d="M7.25 5.73529V4.5H8.75V5.73529H7.25ZM7.25 11.5V6.55882H8.75V11.5H7.25Z"
              fill={theme.colors.white}
            />
          </svg>
          Your CSV file contains invalid rows. Please correct these errors and
          upload file again.
        </Title>
      </Notification>
      <Notification>
        <Inner>
          <Text $type="smallBold" $color="gray">
            Row
          </Text>
          <Text $type="smallBold" $color="gray">
            Error Message
          </Text>
          {rows.map((row) => (
            <Fragment key={row}>
              <Text $type="smallBold">{row}</Text>
              <Text $type="smallBold">{errors[row as any]}</Text>
            </Fragment>
          ))}
        </Inner>
      </Notification>
    </Wrap>
  );
};

export default CsvImportErrors;
